export class Helpers {
  /** Gets the url from the browser */
  static getBaseUrl(): string {
    let pathArray = location.href.split('/');
    let protocol = pathArray[0];
    let host = pathArray[2];

    return protocol + '//' + host;
  }

  static createClass<I, C>(c: { new(I?): C }, rawObject?: I): C {
    if (rawObject) {
      return new c(rawObject);
    }

    return new c();
  }

  static createClassArray<I, C>(c: { new(I): C }, rawObjects: Array<I>): C[] {
    let returnedArray: Array<C> = [];

    if (rawObjects) {
      rawObjects.forEach(t => {
        let obj = new c(t);
        returnedArray.push(obj);
      });
    }

    return returnedArray;
  }
}